/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2025, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

/**
 * Search constants
 */
export const SEARCH_CONSTANTS = {
  MIN_PREFIX_LENGTH: 3,
  SEARCH_RESULTS_STATE: 'searchresults',
  SEARCH_RESULTS_SIZE: 20,
} as const;

/**
 * Supported search scopes.
 */
export const SEARCH_SCOPES = {
  ALL: 'ALL',
  PORTFOLIO: 'PORTFOLIO',
  ORGANIZATIONS: 'ORGANIZATIONS',
} as const;

export type SearchScope = typeof SEARCH_SCOPES[keyof typeof SEARCH_SCOPES];

/**
 * Search request parameters
 */
export interface SearchParams {
  query: string;
  userUnitId?: string | null;
  scope?: SearchScope;
  from?: number;
  size?: number;
}

/**
 * Search result item
 */
export interface SearchResultItem {
  id: string;
  title: string;
  description?: string;
  url?: string;
  // Add other fields as needed based on actual API response
}

/**
 * Search results response
 */
export interface SearchResults {
  items: SearchResultItem[];
  total: number;
  from: number;
  size: number;
}

/**
 * Suggest request parameters
 */
export interface SuggestParams {
  prefix: string;
  filter?: string | null;
  sort?: string | null;
}
